import styled from "styled-components"

export const SwiperWrapper = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: unset;

  .swiper-container {
    overflow: initial;
    height: 100%;
  }

  .swiper-wrapper {
    height: 100%;
  }

  .swiper-slide {
    visibility: hidden;
    &.swiper-slide-active {
      visibility: initial;
    }
  }

  .swiping {
    .swiper-slide {
      visibility: initial;
    }
  }
`
